var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path == '/provider-advisor/providers/' + _vm.routeParams)?_c('Home'):_vm._e(),_c('Member'),_c('PriorAuths'),_c('Providers'),_c('Advisors'),_c('Bundles'),_c('Networks'),_c('Contracts'),_c('Settings'),_c('Employers'),_c('Rates')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }